<template>
  <a-modal title='审核' :width='800' :visible='visible' :confirmLoading='confirmLoading' @ok='handleOk' @cancel='close'
           cancelText='关闭'>

    <a-spin :spinning='confirmLoading'>
      <a-form>
        <a-form-item label="审核结果" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select placeholder="请选择" v-model="formData.status" >
            <a-select-option :value="0">待审核</a-select-option>
            <a-select-option :value="1">审核成功</a-select-option>
            <a-select-option :value="2">审核失败</a-select-option>
          </a-select>
        </a-form-item>

<!--        <a-form-item v-show="formData.approveStatus == 2" label="审核结果" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-textarea :rows='3' placeholder='请输入拒绝原因(80字以内)' v-model="formData.approveContent"  :maxlength="80"/>-->
<!--        </a-form-item>-->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import { approve } from '@/api/user/brokerage'

export default {
  name: 'CrudForm',
  components: {

  },
  props: {

  },
  data() {
    return {
      formData: {

      },           // 表单数据
      visible: false,         // 弹窗显示控制
      confirmLoading: false,  // 提交后加载, 防止短时间内重复提交

      labelCol: { xs: { span: 24 }, sm: { span: 5 } },    // 表单项标签宽度配置
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } }, // 表单项内容宽度配置
    }
  },
  methods: {
    /**
     * 外部方法, 外部调用此方法 打开编辑表单
     * @param {*} record 数据
     */
    audit(record) {
      this.formData = record;
      this.confirmLoading = false;
      this.visible = true;
    },

    /**
     * 关闭表单, 触发 close 事件
     */
    close() {
      this.$emit('close')
      this.visible = false
    },
    /**
     * 提交
     */
    handleOk() {
      this.confirmLoading = true;
      if (this.formData.status == 0) {
        this.$message.warn("请选择审核结果");
        this.confirmLoading = false;
        return;
      }
      approve(this.formData).then(res => {
        if (res.success) {
          this.$message.success(res.message);
          this.close()
          this.$emit('ok');
        } else {
          this.$message.warning(res.message)
        }

      }).finally(() => {
        this.submitLoading = false
      })
    },
  }
}
</script>

<style lang='less' scoped></style>